export default "__VITE_ASSET__C16GiTC5__"